import { TestFunction } from 'yup';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { AnyObject } from 'yup/es/types';
import { IValidationProperties } from '../validation';

export enum QUERY_PARAMS {
  UI_LOCALES = 'ui_locales',
  BRAND_ID = 'brand',
  BRAND_EXT_ID = 'ext-brand',
  BRAND_GROUP_ID = 'brandGroup',
  INITIATE_LOGIN_URI = 'initiateLoginUri',
  APPLICATION_URL = 'applicationUrl',
  ARTICLE_ID_EXT = 'ext-articleId',
  ARTICLE_ID = 'articleId',
  CONSENT_ID = 'consentId',
  EMAIL = 'email',
  STATE = 'state',
  CODE = 'code',
  UTM_INTERNAL = 'ext-internal',
  COOKIE_ID = 'ext-cid',
  SESSION_ID = 'ext-prsid',
  LOCATION = 'ext-location',
  SCREEN_TYPE = 'screenType',
  TRACE_ID = 'traceid',
  ERROR = 'error_type',
  NAME = 'name',
  INVITE_ID = 'inviteId',
  FLOW_ID = 'flowId',
}

export enum GenderType {
  MALE = 'Male',
  FEMALE = 'Female',
  OTHER = 'Other',
}

export interface RegistrationCompletionFormValues {
  birthDateDay?: number;
  birthDateMonth?: number;
  birthDateYear?: number;
  genderType?: GenderType;
  genderCustom?: string;
  optinNewsletter?: boolean;
  optinPromotions?: boolean;
}

export const GENDER_TYPES = Object.keys(GenderType);

// Returns translation key per validation,
// React components have i18next UseTranslation hook to pick up the provided key.
const dateValidation: TestFunction<number | undefined, AnyObject> = (value, ctx) => {
  if (!ctx.parent.birthDateDay && !ctx.parent.birthDateMonth && !ctx.parent.birthDateYear) {
    return true; // required validation is done on field level. If all are null then it's valid
  }
  if (!ctx.parent.birthDateDay || !ctx.parent.birthDateMonth || !ctx.parent.birthDateYear) {
    return false; // required validation is done on field level. If any of them is null then it's invalid
  }
  return (
    dayjs(`${ctx.parent.birthDateYear}-${ctx.parent.birthDateMonth}-01`).daysInMonth() >=
      ctx.parent.birthDateDay &&
    dayjs(
      `${ctx.parent.birthDateYear}-${ctx.parent.birthDateMonth}-${ctx.parent.birthDateDay}`
    ).isBefore(dayjs())
  );
};

export const formSchema = (props: IValidationProperties) => {
  return Yup.object().shape({
    birthDateDay: Yup.number()
      // .required() // Temporary not required because user testing, see MHNLSD-124635
      .notRequired() // Temporary not required because user testing
      .transform((curr, orig) => (orig === '' ? null : curr))
      .min(1)
      .max(31)
      .test('valid-date', 'valid-date', dateValidation),
    birthDateMonth: Yup.number()
      // .required() // Temporary not required because user testing, see MHNLSD-124635
      .notRequired() // Temporary not required because user testing
      .min(1)
      .max(12)
      .test('valid-date', 'valid-date', dateValidation),
    birthDateYear: Yup.number()
      // .required() // Temporary not required because user testing, see MHNLSD-124635
      .notRequired() // Temporary not required because user testing
      .min(1900)
      .max(dayjs().get('year'))
      .test('valid-date', 'valid-date', dateValidation),
    genderType: Yup.mixed()
      // .required('register.error.genderTypeRequired') // Temporary not required because user testing, see MHNLSD-124635
      .notRequired() // Temporary not required because user testing
      .oneOf(GENDER_TYPES),
    genderCustom: Yup.string()
      .optional()
      .max(
        props.maxGenderCustomLength,
        `Gender custom must be max ${props.maxGenderCustomLength} characters`
      ),
    optinNewsletter: Yup.boolean().optional(),
    optinPromotions: Yup.boolean().optional(),
  });
};

export interface RegisterCompletionUserResponse {}
